<template>

    <div class="modal fade" id="savedSearches" tabindex="-1" role="dialog" aria-labelledby="savedSearchesModalTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="section-title no-margin" id="savedSearchesModalTitle">Pesquisas guardadas</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body top-padding">

                    <ul class="searches-list">
                        <div v-if="savedSearches.length == 0">Não há pesquisas guardadas.</div>
                        <li v-else v-for="search in savedSearches" :key="search.Id">
                            <a class="ink-button" :href="getLinkPath(search.PathQuery)">{{ search.Name }}</a>
                            <a class="ink-button remove" v-on:click="onDeleteSearch(search.Id)"><i class="far fa-trash-alt"></i></a>
                        </li>

                    </ul>

                </div>
                <div class="modal-footer">
                    <button type="button" class="ink-button" data-dismiss="modal">Fechar</button>
                </div>
            </div>


        </div>
    </div>

</template>

<script>
import SearchService from '../scripts/services/pesquisa.js'
import NewVehiclesSearchService from '../scripts/services/pesquisa-new-vehicle.js'

export default {

    data(){
        return {
            savedSearches: []
        }
    },
    props:{
        isUsedVehicles: {
            type: Boolean,
            default: true
        }
    },
    mounted (){
    },
    methods: {
        async loadData(){
            if (this.isUsedVehicles){
                let r = await SearchService.GetSavedSearches();
                this.savedSearches = r.Result;
            }else{
                let r = await NewVehiclesSearchService.GetSavedSearches();
                this.savedSearches = r.Result;
            }
        },
        async onDeleteSearch(id){
            if (this.isUsedVehicles){
                await SearchService.DeleteSavedSearch(id);
            }else{
                await NewVehiclesSearchService.DeleteSavedSearch(id);
            }
            this.loadData();
            this.$emit("DeletedSavedSearch", id);
            this.$emit("deleted-saved-search", id);
        },
        async loadSavedSearch(filter){
            this.$emit("OnSearchLoaded", filter);
            this.$emit("on-search-loaded", filter);
        },
        getLinkPath(path){
            console.log("window.location",window.location)
            if (!path)
            {
                path = "";
            }
            return window.location.pathname + path;
        }
    }

};
</script>